export const SAVE_IN_PROGRESS_THROTTLE = 1000;
export const ALLERGY_INACTIVE_STATUS = 'Inactive';
export const INACTIVE_THERAPY_CATEGORIES = [3, 4];
